import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

function __getFullTree (fnCallback) {
    return axios.get(utilityService.getApiUrl('user/officemanagement/fulltree'),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getOfficeById (officeId) {
    return axios.get(utilityService.getApiUrl('user/officemanagement/' + officeId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getOfficeBySurveyId (surveyId) {
    return axios.get(utilityService.getApiUrl('user/officemanagement/surveyId/' + surveyId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __searchForOffice (term) {
    return axios.post(utilityService.getApiUrl('office/search/'),
        { Search: term },
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getOfficeTree (officeId) {
    return axios.get(utilityService.getApiUrl('office/nodes/' + officeId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getAllAgencyTrees () {
    return axios.get(utilityService.getApiUrl('office/nodes/'),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getSurveyByOfficeId (officeId) {
    return axios.get(utilityService.getApiUrl('office/nodes/' + officeId + '/survey'),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}
function __getAllOfficesByDepth (depth) {
    return axios.get(utilityService.getApiUrl('office/details/depth/' + depth),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}
/**
 * Gets the support request search results.
 * @param criteria Object - The search parameters to use for the search.
 */
function __searchSupportRequests (criteria) {
	return axios.post(utilityService.getApiUrl('office/support/request/search/'),
		criteria,
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __getSupportRequestsSummary () {
	return axios.get(utilityService.getApiUrl('office/support/request/summary/'),
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __getUserContactDetails (currentuser, volume) {
	return axios.get(utilityService.getApiUrl(`user/officemanagement/usercontact/${currentuser}/currentVolume/${volume}`),
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __saveOfficeContact (currentuser, usercontactInfo) {
	// /api/survey/section/2
	return axios.post(utilityService.getApiUrl('user/'+currentuser),usercontactInfo,
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	);
}

function __getSubOffices (surveyId) {
    return axios.get(utilityService.getApiUrl('office/suboffices/surveyId/' + surveyId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getAvaiableOffices () {
    return axios.get(utilityService.getApiUrl('office/avaiableoffices/'),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getAvaiableSubOffices (surveyId) {
    return axios.get(utilityService.getApiUrl('office/avaiablesuboffices/surveyId/' + surveyId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getAllDepartments (departmentTypeId) {
    return axios.get(utilityService.getApiUrl('userregister/departments/' + departmentTypeId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getAllOfficesOfCurrentVolume (officename) {
    return axios.get(utilityService.getApiUrl('office/alloffices/officename/' + officename),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getSupportRequest (request, flag) {
	return axios.get(utilityService.getApiUrl('office/support/service/request/' + request + '/flag/' + flag),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
	);
}

	function __getAllSupportTopics () {
    return axios.get(utilityService.getApiUrl('lookup/support/service/topicTypes/'),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __saveSupportRequest (id, agency, program, field, branch, officeName, officeId, userId, firstName, lastName, title, phone, email, contactPerson, assignedTo, testedBy,
	contactType, contactEmailCount, contactPhoneCount, contactOtherCount, requestStatus, description, topicType, department, problemTypes, addorupdateflag, createDate) {
	return axios.post(utilityService.getApiUrl('office/saveSupportRequest/'),
     { 	Id: id, Agency: agency, Program: program, Field: field, Branch: branch, OfficeName: officeName, OfficeId: officeId, UserId: userId,
				FirstName: firstName, LastName: lastName, Title: title, Phone: phone, Email: email, ContactPerson: contactPerson, AssignedTo : assignedTo, TestedBy : testedBy,
				ContactType: contactType, ContactEmailCount: contactEmailCount, ContactPhoneCount: contactPhoneCount, ContactOtherCount: contactOtherCount, RequestStatus: requestStatus, Description: description, TopicType: topicType,
				Department: department, ProblemTypes: problemTypes, addorupdateflag: addorupdateflag
			},
		{
			headers: utilityService.getHeaders()
		});
}

export const officeManagementService = {
    getFullTree: () => __getFullTree(),
    getOfficeById: (officeId) => __getOfficeById(officeId),
    getOfficeBySurveyId: (surveyId) => __getOfficeBySurveyId(surveyId),
    searchForOffice: (term) => __searchForOffice(term),
    getAllOfficesByDepth: (depth) => __getAllOfficesByDepth(depth),
    getOfficeTree: (officeId) => __getOfficeTree(officeId),
    getAllAgencyTrees: () => __getAllAgencyTrees(),
		getSurveyByOfficeId: (officeId) => __getSurveyByOfficeId(officeId),
		searchSupportRequests: (criteria) => __searchSupportRequests(criteria),
		getSupportRequestsSummary: () => __getSupportRequestsSummary(),
    getUserContactDetails: (currentuser, currentVolume) => __getUserContactDetails(currentuser, currentVolume),
    saveOfficeContact: (currentuser, usercontactInfo) => __saveOfficeContact(currentuser, usercontactInfo),
    getSubOffices: (surveyId) => __getSubOffices(surveyId),
    getAllDepartments: (departmentTypeId) => __getAllDepartments(departmentTypeId),
    getAvaiableSubOffices: (surveyId) => __getAvaiableSubOffices(surveyId),
    getAvaiableOffices: () => __getAvaiableOffices(),
    getAllOfficesOfCurrentVolume: (officename) => __getAllOfficesOfCurrentVolume(officename),
		getSupportRequest: (request, flag) => __getSupportRequest(request, flag),
		getAllSupportTopics: () => __getAllSupportTopics(),
		saveSupportRequest: (id, agency, program, field, branch, officeName, officeId, userId, firstName, lastName, title, phone, email, contactPerson, assignedTo, testedBy, contactType, contactEmailCount, contactPhoneCount, contactOtherCount, requestStatus, description, topicType, department, problemTypes, addorupdateflag) => __saveSupportRequest(id, agency, program, field, branch, officeName, officeId, userId, firstName, lastName, title, phone, email, contactPerson, assignedTo, testedBy,	contactType, contactEmailCount, contactPhoneCount, contactOtherCount, requestStatus, description, topicType, department, problemTypes, addorupdateflag)
};
